export default (superClass) => {
    return class extends superClass {
        get minAmount() {
            return this._data.amount_from;
        }

        get maxAmount() {
            return this._data.amount_to;
        }
        
        get maxAmountToExistingCustomers() {
            return this._data.amount_to_existing_customers;
        }

        get minAmountDebtCollection() {
            return this._data.amount_from_debt_collection || this.minAmount;
        }

        get maxAmountDebtCollection() {
            return this._data.amount_to_debt_collection || this.maxAmount;
        }

        get absoluteMinAmount() {
            const minAmounts = [this.minAmount, this.minAmountDebtCollection].filter(Boolean);
            return minAmounts.length 
                ? Math.min(...minAmounts)
                : 0;
        }

        get absoluteMaxAmount() {
            const maxAmounts = [this.maxAmount, this.maxAmountDebtCollection, this.maxAmountToExistingCustomers]
                .filter(Boolean);
            return maxAmounts.length 
                ? Math.max(...maxAmounts)
                : 0;
        }

        get minAmountString() {
            return this.formatCurrency(this.minAmount); 
        }

        get maxAmountString() {
            return this.formatCurrency(this.maxAmount);
        }

        get minAmountDebtCollectionString() {
            return this.formatCurrency(this.minAmountDebtCollection);
        }

        get maxAmountDebtCollectionString() {
            return this.formatCurrency(this.maxAmountDebtCollection);
        }

        get absoluteMinAmountString() {
            return this.formatCurrency(this.absoluteMinAmount);
        }

        get absoluteMaxAmountString() {
            return this.formatCurrency(this.absoluteMaxAmount);
        }

        get amountString() {

            if(this.minAmount == this.maxAmount) {
                return this.minAmountString;
            }

            return this.formatCurrencyRange(this.minAmount, this.maxAmount);
        }

        get amountDebtCollectionString() {
            if (this.minAmountDebtCollection == this.maxAmountDebtCollection) {
                return this.formatCurrency(this.minAmountDebtCollection);
            }

            return this.formatCurrencyRange(this.minAmountDebtCollection, this.maxAmountDebtCollection);
        }

        get absoluteAmountString() {
            if (this.absoluteMinAmount == this.absoluteMaxAmount) {
                return this.absoluteMinAmountString;
            }

            return this.formatCurrencyRange(this.absoluteMinAmount, this.absoluteMaxAmount);
        }

        get hasDebtCollectionAmount() {
            const validateValue = (debtCollectionValue, value) => {
                return Boolean(debtCollectionValue) && debtCollectionValue > 0 && debtCollectionValue !== value
            }

            return validateValue(this._data.amount_from_debt_collection, this.minAmount) ||
                validateValue(this._data.amount_to_debt_collection, this.maxAmount);
        }

        get hasExtraLoanAmountToExistingCustomers() {
            return this.maxAmountToExistingCustomers && 
                this.maxAmountToExistingCustomers > 0;
        }

        get maxAmountToExistingCustomersString() {
            return this.formatCurrency(this.maxAmountToExistingCustomers);
        }

        getMaxAmountToExistingCustomersString(template = 'Upp till {amount} till existerande kunder') {
            return template.replace('{amount}', this.maxAmountToExistingCustomersString);
        }
    }
}